import { useTranslation } from "react-i18next";
import swisstainableLogo from '../static/images/swisstainable/logo.png';
import React from "react";
import { Link } from "react-router-dom";

export default function SwisstainableSection() {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424] hidden xl:block">{t('Homepage.swisstainableTitle.title')}</h1>
                <h2 className="text-[#225424] hidden md:block xl:hidden">{t('Homepage.swisstainableTitle.title')}</h2>
                <h3 className="text-[#225424] md:hidden">{t('Homepage.swisstainableTitle.title')}</h3>
            </div>
            <div className="mt-8 md:mt-16 w-full lg:w-[1000px] flex justify-start">
                <Link
                    to="https://www.myswitzerland.com/it-ch/pianificazione/informazioni-sulla-svizzera/sostenibilita/"
                >
                    <img
                        src={swisstainableLogo}
                        alt="Swisstainable Logo"
                        className='w-[100px] md:w-[160px]'
                    />
                </Link>
            </div>
        </React.Fragment>
    )
}